<div class="federated-redirect-overlay" *ngIf="isVisible()">
  <div class="federated-redirect-overlay__content flex column align-center gap-4">
    <div class="loader white w-50"></div>
    <p class="federated-redirect-overlay__text">{{ 'auth.common.modal.federatedRedirectLoading' | translate }}</p>
  </div>
</div>
